import { useState } from "react";
import { Pencil, Save, X, Loader2 } from "lucide-react";

export const BriefEditor = ({ lead, i, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(lead.ai.brief);
  const [saving, setSaving] = useState(false);

  const start = () => {
    setDraft(lead.ai.brief);
    setEditing(true);
  };

  const save = async () => {
    if (saving || draft.trim().length < 10) return;
    setSaving(true);
    const ok = await onSave(lead.id, draft);
    setSaving(false);
    if (ok) setEditing(false);
  };

  if (!editing) {
    return (
      <div className="mt-3">
        <pre className="max-h-80 overflow-auto whitespace-pre-wrap rounded-xl bg-white p-4 font-sans text-xs leading-relaxed text-slate-700" data-testid={`admin-lead-brief-${i}`}>
          {lead.ai.brief}
        </pre>
        <div className="mt-2 flex items-center justify-between gap-2">
          {lead.ai.edited_at ? (
            <span className="text-[10px] text-slate-400" data-testid={`admin-lead-brief-edited-${i}`}>Modifié par vous</span>
          ) : <span />}
          <button
            data-testid={`admin-lead-edit-brief-${i}`}
            onClick={start}
            className="flex items-center gap-1.5 rounded-full border border-navy/15 bg-white px-3 py-1.5 text-[11px] font-semibold text-navy transition-colors hover:border-gold hover:text-gold-dark"
          >
            <Pencil size={11} /> Modifier le brief
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-3">
      <textarea
        data-testid={`admin-lead-brief-textarea-${i}`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        rows={14}
        className="w-full resize-y rounded-xl border border-gold/50 bg-white p-4 font-sans text-xs leading-relaxed text-slate-700 outline-none focus:border-gold"
      />
      <div className="mt-2 flex items-center justify-end gap-2">
        <button
          data-testid={`admin-lead-cancel-brief-${i}`}
          onClick={() => setEditing(false)}
          className="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-semibold text-slate-500 transition-colors hover:text-navy"
        >
          <X size={11} /> Annuler
        </button>
        <button
          data-testid={`admin-lead-save-brief-${i}`}
          onClick={save}
          disabled={saving || draft.trim().length < 10}
          className="flex items-center gap-1.5 rounded-full bg-navy px-3.5 py-1.5 text-[11px] font-semibold text-white transition-all hover:bg-navy-light disabled:opacity-60"
        >
          {saving ? <Loader2 size={11} className="animate-spin" /> : <Save size={11} />} {saving ? "Enregistrement…" : "Enregistrer"}
        </button>
      </div>
    </div>
  );
};
